// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"ddf37e94","220":"734dd961","586":"c1dc0d01","923":"8fc32947","932":"35ee0863"}[chunkId] + ".chunk.js";
};